/** @format */
import { useQuery } from '@tanstack/react-query';

import { Milliseconds } from '@toucan/config/durations';
import { MarketCode } from '@toucan/config/markets';

import { getProductSummary } from '@toucan/services/requests/products';

import { ProductSummaryV2 } from '@toucan/client/global/product';

export const useProductSummary = (productId: number, market: MarketCode) => {
    return useQuery<ProductSummaryV2>({
        queryKey: ['product-summary', productId],
        queryFn: () => getProductSummary(productId, market),
        staleTime: Milliseconds.ONE_HOUR,
    });
};
